export default "__VITE_ASSET__940184b8__"